import tw from "twin.macro";
import { motion } from "framer-motion";
import { dateMonthYearFormatUtcToLocal } from "../utility/Constant";
import { useState } from "react";
import PaymentTab from "./PaymentTab.js";
import { onlinePayment } from "../api/MySchemeApi";
import { getBranchId } from "utility/HeaderConfig";

const TabContent = tw(motion.div)`block`;

const CHIP_STYLE = {
  display: "inline-flex", alignItems: "center", gap: 6,
  padding: "6px 14px", borderRadius: 999, fontSize: 12, fontWeight: 700,
};

const TABLE_LABEL = {
  fontSize: 11, fontWeight: 700, color: "#9898a6", textTransform: "uppercase", letterSpacing: ".08em", width: "30%",
};

const TABLE_VALUE = {
  fontSize: 13, fontWeight: 600, color: "#2d1752", paddingLeft: 8,
};

function DataRow({ label, value, accent }) {
  return (
    <tr>
      <td style={TABLE_LABEL}>{label}</td>
      <td style={{ fontSize: 12, color: "#aaa", width: 10 }}>:</td>
      <td style={{ ...TABLE_VALUE, color: accent || "#2d1752" }}>{value}</td>
    </tr>
  );
}

export default (props) => {
  const [Tnx, setTnx] = useState([]);
  const [Show, setShow] = useState(true);

  const onlineTransaction = () => {
    const response = onlinePayment({ branchId: getBranchId(), productDesc: props.currentChit.chitId });
    response.then((data) => { setShow(false); setTnx(data.response.content); });
  };

  const details = () => setShow(true);

  return (
    <>
      <motion.div
        initial={{ opacity: 0, scale: 0.94, y: 20 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        transition={{ duration: 0.28, ease: [0.16, 1, 0.3, 1] }}
        style={{ position: "fixed", inset: 0, zIndex: 50, display: "flex", alignItems: "center", justifyContent: "center", padding: "16px" }}
      >
        <div style={{ background: "#fff", borderRadius: 24, boxShadow: "0 32px 100px rgba(0,0,0,.2)", width: "100%", maxWidth: 700, maxHeight: "88vh", display: "flex", flexDirection: "column", overflow: "hidden" }}>

          {/* Modal header */}
          <div style={{ padding: "18px 24px", borderBottom: "1px solid #f0e9fa", display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 12, flexShrink: 0 }}>
            <div>
              <h5 style={{ fontFamily: "Cormorant Garamond,Georgia,serif", fontSize: 22, fontWeight: 700, color: "#2d1752", margin: "0 0 4px" }}>
                Payment History
              </h5>
              <p style={{ fontSize: 12, color: "#9898a6", margin: 0 }}>{props.currentChit?.chitId || ""}</p>
            </div>

            {/* Summary chips */}
            <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
              <span style={{ ...CHIP_STYLE, background: "#e8f5e9", color: "#2e7d32" }}>
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="9 11 12 14 22 4"/><path d="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11"/></svg>
                {props.payDetails.totalCount} Dues
              </span>
              <span style={{ ...CHIP_STYLE, background: "#f3e5f5", color: "#6a1b9a" }}>
                ₹ {props.payDetails.totalAmount}
              </span>
              {props.currentChit?.chitTypeName !== "INR" && props.payDetails.totalNetWeight && (
                <span style={{ ...CHIP_STYLE, background: "#fff8e1", color: "#f57f17" }}>
                  {props.payDetails.totalNetWeight} g
                </span>
              )}
            </div>

            <button onClick={props.close}
              style={{ background: "none", border: "1.5px solid #e5daf5", borderRadius: 8, cursor: "pointer", width: 36, height: 36, display: "flex", alignItems: "center", justifyContent: "center", color: "#6c6c70", transition: "background .14s", flexShrink: 0 }}
              onMouseEnter={(e) => e.currentTarget.style.background = "#f5f0ff"}
              onMouseLeave={(e) => e.currentTarget.style.background = "none"}
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
              </svg>
            </button>
          </div>

          {/* Tabs */}
          <div style={{ flexShrink: 0 }}>
            <PaymentTab onlineTnx={onlineTransaction} paymentHistory={props.close} details={details} states={Show} />
          </div>

          {/* Scrollable content */}
          <div style={{ overflowY: "auto", flex: 1 }}>

            {/* Payment Details tab */}
            <TabContent
              variants={{ current: { opacity: 1, scale: 1, display: "block" }, hidden: { opacity: 0, scale: 0.97, display: "none" } }}
              transition={{ duration: 0.2 }} initial={Show ? "current" : "hidden"} animate={Show ? "current" : "hidden"}
            >
              {props.payDetails.content.map((data, index) => (
                <div key={index} style={{ margin: "12px 16px", borderRadius: 14, border: "1px solid #f0e9fa", overflow: "hidden" }}>
                  {/* Card header */}
                  <div style={{ background: "linear-gradient(135deg,#4f3267,#7517b4)", padding: "10px 16px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <span style={{ fontSize: 12, fontWeight: 700, color: "rgba(255,255,255,.8)", textTransform: "uppercase", letterSpacing: ".06em" }}>Due #{data.dueNumber}</span>
                    <span style={{ fontSize: 12, fontWeight: 600, color: "#fff" }}>
                      {data.paymentDate && data.paymentDate !== "" && data.paymentDate !== "-"
                        ? dateMonthYearFormatUtcToLocal(data.paymentDate) : "—"}
                    </span>
                  </div>
                  {/* Card body */}
                  <div style={{ padding: "14px 16px" }}>
                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                      <tbody>
                        <DataRow label="Receipt No" value={data.seqNum || "—"} />
                        <DataRow label="Rate" value={data.rate ? `₹ ${parseFloat(data.rate).toFixed(2)}` : "₹ 0.00"} />
                        <DataRow label="Paid Amount" value={data.paymentAmount && data.paymentAmount !== "-" ? `₹ ${parseFloat(data.paymentAmount).toFixed(2)}` : "₹ 0.00"} accent="#7517b4" />
                        {props.currentChit?.chitTypeName !== "INR" && (
                          <DataRow label="Accum. Wt" value={data.paymentGrms && data.paymentGrms !== "-" ? `${parseFloat(data.paymentGrms).toFixed(3)} g` : "0.000 g"} />
                        )}
                        {data.bonus !== 0 && <DataRow label="Bonus" value={props.currentChit?.chitTypeName !== "INR" ? data.bonus : "—"} />}
                        <DataRow
                          label="Gift Status"
                          value={data.chitEnrollmentDetails.giftIssueNumber !== "-" ? "Issued" : "Not Issued"}
                          accent={data.chitEnrollmentDetails.giftIssueNumber !== "-" ? "#c0392b" : "#27ae60"}
                        />
                      </tbody>
                    </table>
                  </div>
                </div>
              ))}
              {props.payDetails.content.length === 0 && (
                <div style={{ padding: "48px 24px", textAlign: "center" }}>
                  <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#c8b4e0" strokeWidth="1.5" style={{ margin: "0 auto 12px", display: "block" }}>
                    <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
                  </svg>
                  <p style={{ fontSize: 14, color: "#9898a6", margin: 0 }}>No payment records found</p>
                </div>
              )}
            </TabContent>

            {/* Online Txn Details tab */}
            <TabContent
              variants={{ current: { opacity: 1, scale: 1, display: "block" }, hidden: { opacity: 0, scale: 0.97, display: "none" } }}
              transition={{ duration: 0.2 }} initial={!Show ? "current" : "hidden"} animate={!Show ? "current" : "hidden"}
            >
              {Tnx.map((item, index) => (
                <div key={index} style={{ margin: "12px 16px", borderRadius: 14, border: "1px solid #f0e9fa", overflow: "hidden" }}>
                  <div style={{ background: "linear-gradient(135deg,#1a1a2e,#16213e)", padding: "10px 16px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <span style={{ fontSize: 12, fontWeight: 700, color: "rgba(255,255,255,.7)", textTransform: "uppercase", letterSpacing: ".06em" }}>Order ID</span>
                    <span style={{ fontSize: 12, fontWeight: 600, color: "#fff" }} title={item.orderId}>{item.orderId}</span>
                  </div>
                  <div style={{ padding: "14px 16px" }}>
                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                      <tbody>
                        <DataRow label="Date" value={item.responseDatetime && item.responseDatetime !== "" && item.responseDatetime !== "-" && item.responseDatetime !== null ? dateMonthYearFormatUtcToLocal(item.responseDatetime) : "—"} />
                        <DataRow label="Txn Amount" value={item.authorizedAmount || "—"} accent="#7517b4" />
                        <DataRow label="Txn Type" value={item.txnType || "—"} />
                        <DataRow label="Txn ID" value={item.txnId || "—"} />
                        <DataRow
                          label="Status"
                          value={item.status || "—"}
                          accent={item.status?.toLowerCase() === "success" ? "#27ae60" : item.status?.toLowerCase() === "failure" ? "#c0392b" : "#2d1752"}
                        />
                      </tbody>
                    </table>
                  </div>
                </div>
              ))}
              {Tnx.length === 0 && (
                <div style={{ padding: "48px 24px", textAlign: "center" }}>
                  <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#c8b4e0" strokeWidth="1.5" style={{ margin: "0 auto 12px", display: "block" }}>
                    <rect x="2" y="5" width="20" height="14" rx="2"/><line x1="2" y1="10" x2="22" y2="10"/>
                  </svg>
                  <p style={{ fontSize: 14, color: "#9898a6", margin: 0 }}>No online transactions found</p>
                </div>
              )}
            </TabContent>
          </div>
        </div>
      </motion.div>
      <div style={{ opacity: 0.45, position: "fixed", inset: 0, zIndex: 40, background: "#000" }}></div>
    </>
  );
};